import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { COUNTRY_BY_NAME } from './types';
import { countryTaasByName } from '../../api';

export const fetchCountryByName = (countryName: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const getCustomerByEmailData = countryTaasByName(countryName, state);
  dispatch(thunkProgress(COUNTRY_BY_NAME, getCustomerByEmailData, { countryName }));
};
